import { CustomerKeyType } from '../../constants';

export type Wishlist = {
  customerKey: string;
  wishlistId: number;
  customerKeyType: CustomerKeyType;
  skus: string[];
  createdAt: Date;
};
